// src/pages/CreateUser.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

export default function CreateUser() {
  const { token } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'Employee',
  });

  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/users`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate('/users');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create user');
    }
  };

  return (
    <div className="container mt-4">
      <h2>Create New User</h2>
      <form onSubmit={handleSubmit} className="w-50">
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
          className="form-control mb-3"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          className="form-control mb-3"
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          className="form-control mb-3"
          required
        />
        <select
          name="role"
          value={form.role}
          onChange={handleChange}
          className="form-select mb-3"
        >
          <option value="Employee">Employee</option>
          <option value="Executive">Executive</option>
          <option value="IT">IT</option>
        </select>
        <button className="btn btn-success">Create User</button>
        {error && <p className="text-danger mt-2">{error}</p>}
      </form>
    </div>
  );
}
